import { IAccountCrudModalLang } from '../../../types/lang'

export const accountCrudModalLang: IAccountCrudModalLang = {
	account_crud_modal: {
		title_create: 'Create account_ru',
		title_edit: 'Edit account_ru',
		title_clone: 'Clone account from base account_ru',
		title_deleted: 'Deleted accounts_ru',
		title_remove_single: 'Remove <span>account_ru</span>',
		title_remove_multiple: 'Remove <span>accounts_ru</span>',
		title_remove_multiple_cnt: 'Remove <span>{{cnt}} selected account(s)_ru</span>',
		field_email_label: 'Email_ru',
		field_email_placeholder: 'Email_ru',
		field_is_active_label: 'Active_ru',
		field_is_active_placeholder: 'Active_ru',
		field_is_fired_label: 'Fired_ru',
		field_role_label: 'Role_ru',
		field_role_placeholder: 'Role_ru',
		field_login_label: 'Login_ru',
		field_login_placeholder: 'Login_ru',
		field_password_label: 'Password_ru',
		field_password_placeholder: 'Password_ru',
		field_kt_group_label: 'KT Group_ru',
		field_kt_group_placeholder: 'KT Group_ru',
		field_date_registered_label: 'Date Registered_ru',
		field_date_registered_placeholder: 'Date Registered_ru',
		msg_remove_confirm: 'Are you sure?_ru',
		msg_resurrect_success: 'Account {{account}} is resurrected successfully!_ru',
		msg_resurrect_error: 'Account {{account}} was NOT resurrected._ru',
		btn_create: 'Create_ru',
		btn_update: 'Save_ru',
		btn_clone: 'Clone_ru',
		btn_remove: 'Remove_ru',
		btn_close: 'Close_ru'
	}
}